import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    // historyComponent: Autocomplete,
    autocompleteComponent: Autocomplete,
    autocompleteMinLength: 1,
    categoryComponent: Category,
    inputCssSelector: defaultConfig.inputCssSelector,
    dropdownCssSelector: "#nosto-search-autocomplete",
    contentCssSelector: "#nosto-search-results-id",
    persistentSearchCache: true,
    preservePageScroll: true,
    // formCssSelector: "#search-form",
    hitDecorators: [
        thumbnailDecorator({ size: "9" })
    ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',
    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                // "name",
                // "imageUrl",
                // "imageHash",
                // "thumbUrl",
                // "description",
                // "brand",
                // "availability",
                // "price",
                // "priceText",
                // "listPrice",
                // "ratingValue",
                // "reviewCount",
                'customFields.key', 
                'customFields.value',
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },

    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                // "name",
                // "imageUrl",
                // "thumbUrl",
                // "brand",
                // "availability",
                // "price",
                // "priceText",
                // "listPrice",
                // "ratingValue",
                // "reviewCount",
                'customFields.key', 
                'customFields.value',
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // Uncomment for Category Merchandising
    categoryCssSelector: '#nosto-category-page-id',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
})
